import $ from 'jquery';
import {getSetting} from "@ppcp/utils";
import {isEqual} from 'lodash';
import Actions from '@ppcp/actions';

class Product {

    constructor(settings = {}) {
        this.actions = new Actions(); // Shared actions instance (singleton)
        this.data = this.default_data = settings;
        this.variation = false;
        $(document.body).on('change', '[name="quantity"]', this.onQuantityChange.bind(this));
        $(document.body).on('found_variation', this.foundVariation.bind(this));
        $(document.body).on('reset_data', this.resetVariationData.bind(this));
    }

    needsShipping() {
        return this.data?.needsShipping;
    }

    getLineItems() {
        return this.data.lineItems || [];
    }

    isVariationSelected() {
        return !!this.variation;
    }

    onQuantityChange(e) {
        if (e?.isTrigger) {
            //cause a short delay so this won't execute before found_variation
            setTimeout(() => {
                this.actions.doAction('quantity_change', this.getQuantity(), this);
            }, 50);
        } else {
            this.actions.doAction('quantity_change', this.getQuantity(), this);
        }
    }

    foundVariation(e, variation) {
        this.variation = variation;
        const prevData = {...this.data};
        this.data = {
            ...this.data, ...{
                price: variation.display_price,
                needsShipping: !variation.is_virtual
            }
        };
        this.actions.doAction('found_variation', !isEqual(this.data, prevData), this);
    }

    resetVariationData() {
        this.variation = null;
        this.data = this.default_data;
        this.actions.doAction('reset_variation', this);
    }

    getQuantity() {
        return parseInt($('[name="quantity"]').val()) || 0;
    }

    getPrice() {
        return this.data?.price;
    }

    getTotal(type = 'string') {
        const total = this.getQuantity() * this.getPrice();
        if (type === 'string') {
            return total.toString();
        }
        return total;
    }

    getTotalCents() {
        return parseInt(this.data?.totalCents || 0);
    }

    isVariableProduct() {
        return $('[name="variation_id"]').length > 0;
    }

    isVariableProductSelected() {
        const val = $('input[name="variation_id"]').val();
        return !!val && "0" !== val;
    }

    getVariationData() {
        if (this.isVariableProduct()) {
            const attributes = this.variation ? this.variation.attributes : {};
            const elements = document.querySelectorAll('.variations [name^="attribute_"]');
            if (elements) {
                elements.forEach((element) => {
                    if (!(element.name in attributes) || (attributes[element.name] === '')) {
                        attributes[element.name] = element.value || '';
                    }
                });
            }
            return attributes;
        }
        return null;
    }

    getId() {
        return parseInt(this.data?.id);
    }

    getVariationId() {
        if (this.variation) {
            return this.variation.variation_id;
        }
        return $('[name="variation_id"]').val();
    }
}

export {Product};
export default new Product(getSetting('product'));